import { Router, Route, hashHistory } from 'react-router';
import { reaction } from 'mobx';
import EventStore from '@stores/EventStore';
import WelcomePage from '@pages/WelcomePage';
import VerifyPage from '@pages/VerifyPage';
import AgreementPage from '@pages/AgreementPage';
import BillingCreditPage from '@pages/BillingCreditPage';
import PaymentPage from '@pages/PaymentPage';
import MessagePage from '@pages/MessagePage';
import GenericSignaturePage from '@pages/GenericSignaturePage';
import React from 'react';

export default class RouteConfig extends React.Component {
    constructor(props) {
        super(props);
    }

    endReaction = reaction(() => EventStore.eventObj, () => {
        var pageMap = {
            tAc: 'agreements',
            creditApp: 'billingcredit',
            payment: 'payment',
            verifyPin: 'verify',
            status: 'message',
            signatureCapture: 'signature'
        },
        page = '';

        if(EventStore.eventObj.event === 'pageNavigation') {
            page = pageMap[EventStore.eventObj.payload.pageName] ? pageMap[EventStore.eventObj.payload.pageName] : '';
            hashHistory.replace(page);
        }
    })

    render() {
        return (
            <div>
                <Router history={hashHistory}>
                    <Route path="/" component={WelcomePage} />
                    <Route path="/verify" component={VerifyPage} />
                    <Route path="/agreements" component={AgreementPage} />
                    <Route path="/billingcredit" component={BillingCreditPage} />
                    <Route path="/payment" component={PaymentPage} />
                    <Route path="/message" component={MessagePage} />
                    <Route path="/signature" component={GenericSignaturePage} />
                </Router>
            </div>
        );
    }

    componentWillUnmount() {
        this.endReaction();
    }
}


// WEBPACK FOOTER //
// ./src/RouteConfig.js